<template>
  <div class="retailer-filters-container">
    <div :class="['button', showRetailers ? 'open' : 'closed', {empty: !hasAnyRetailers}]"
        @click="showRetailers = !showRetailers">{{filterHeaderText}}</div>

    <div v-if="hasAnyRetailers" class="retailer-filters-wrapper">
      <div :class="['retailers-filter-list', showRetailers ? 'slide-down' : 'slide-up']">
        <div v-for="retailer in retailers" :key="retailer.id" class="retailer-filter-item">
          <label>
            <div class="retailer-label-wrapper">
              <input
                :value="retailer.id"
                type="checkbox"
                v-model="selectedRetailerIds">
              <span class="checkbox-checkmark"></span>
              <span class="label-name">{{retailer.name}}</span>
            </div>
            <span class="label-consumers">{{abbrNum(retailer.sms_list_size, 2)}} consumers</span>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { NumberFormatters } from '../mixins/NumberFormatters.js'

  export default {
    props: {
      retailers: Array
    },

    mixins: [ NumberFormatters ],

    data() {
      return {
        selectedRetailerIds: [],
        showRetailers: false,
      }
    },

    computed: {
      filterHeaderText: function() {
        const selected = this.selectedRetailerIds,
          total = this.retailers?.length || null,
          hasSelected = total && selected.length,
          notSelectedText = this.hasAnyRetailers ? 'show specific retailers' : 'no available retailers'
        return hasSelected ? `showing ${selected.length} / ${this.retailers.length} retailers` : notSelectedText
      },

      hasAnyRetailers() {
        return !!this.retailers?.length
      }
    },

    watch: {
      selectedRetailerIds: function() {
        this.$emit('setSelectedRetailerIds', this.selectedRetailerIds)
      }
    }

  }
</script>

<style lang="sass">
@import '../../assets/sass/colors'

.performance
  .retailer-filters-container
    .button
      align-items: center
      display: flex
      font-size: 0.9rem
      padding: .5rem 2rem
      z-index: 1

      &:after
        border-bottom: 1px solid #fff
        border-right: 1px solid #fff
        content: ' '
        display: inline-block
        height: 10px
        width: 10px

      &.closed
        &:after
          margin: 0 0 .15rem .75rem
          transform: rotate(45deg)

      &.open
        &:after
          margin: 0 0 -.2rem .75rem
          transform: rotate(-135deg)

      &.empty
        &:after
          display: none

    .retailer-filters-wrapper
      position: relative
      width: 100%

    .retailers-filter-list
      background: white
      border: 1px solid $primary-color
      border-radius: 0 0 8px 8px
      border-top: none
      left: .75rem
      max-height: 400px
      overflow: auto
      padding: 0 1rem
      position: absolute
      right: .75rem
      text-align: left
      z-index: 11

      &.slide-up
        margin-top: -2px
        max-height: 0
        overflow: hidden
        transition: max-height 0.4s, margin-top 0.01s ease 0.4s

      &.slide-down
        max-height: 400px
        transition: max-height 0.4s

    .retailer-filter-item
      margin: .75rem 0
      position: relative

      label
        cursor: pointer

    .retailer-label-wrapper
      align-items: flex-start
      display: flex
      margin-bottom: .15rem

      &:hover input ~ .checkbox-checkmark
        border: 1px solid $tertiary-color

    .label-name
      color: $primary-color
      font-size: 1rem
      line-height: 100%
      margin-left: .5rem

      &:hover
        color: $tertiary-color

    .label-consumers
      color: $negative-color
      display: block
      font-size: .8rem
      margin-left: 24px

    .checkbox-checkmark
      background-color: #fff
      border: 1px solid $primary-color
      border-radius: 5px
      display: inline-block
      min-height: 14px
      min-width: 14px

    input
      display: none

    input:checked ~ .checkbox-checkmark
      background-color: $primary-color

    input:checked ~ .label-name
      color: $title-color

</style>
